import { Product } from "@deliverr/commons-clients";

/**
 * FEFO is the first-expiry-first-out method of fulfillment, which prioritizes based on earliest expiration date
 */
export const getProductIsFefoEnabled = ({ isFefoEnabled }: Product): boolean => !!isFefoEnabled;
